import {IMapOffer} from "../../maps/types/IMapOffer";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IRelatedOfferList} from "../list/types/IOfferListResponse";

export const transformRelatedOfferIntoMapOffer = (offer: IRelatedOfferList): IMapOffer => ({
    id: offer.id,
    name: offer.name,
    coordinates: offer.geo_point.coordinates,
    vendorName: offer.vendor.name,
    vendorLogo: getThumbnailLink(offer.vendor.logo_url, 80, 60) ?? offer.vendor.logo?.v_log_80x60,
    description: `Liczba mieszkań: ${offer.properties}`,
    mainImage: {
        desktop: getThumbnailLink(offer.main_image_url, 375, 211) ?? offer.main_image?.m_img_375x211 ?? undefined,
        mobile: getThumbnailLink(offer.main_image_url, 155, 87) ?? offer.main_image?.m_img_155x87 ?? undefined
    },
    distance: offer.stats?.distance_from_region.distance,
    region: {
        country: offer.region.country
    }
});
import {IMapOffer} from "../../maps/types/IMapOffer";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IRelatedOfferList} from "../list/types/IOfferListResponse";

export const transformRelatedOfferIntoMapOffer = (offer: IRelatedOfferList): IMapOffer => ({
    id: offer.id,
    name: offer.name,
    coordinates: offer.geo_point.coordinates,
    vendorName: offer.vendor.name,
    vendorLogo: getThumbnailLink(offer.vendor.logo_url, 80, 60) ?? offer.vendor.logo?.v_log_80x60,
    description: `Liczba mieszkań: ${offer.properties}`,
    mainImage: {
        desktop: getThumbnailLink(offer.main_image_url, 375, 211) ?? offer.main_image?.m_img_375x211 ?? undefined,
        mobile: getThumbnailLink(offer.main_image_url, 155, 87) ?? offer.main_image?.m_img_155x87 ?? undefined
    },
    distance: offer.stats?.distance_from_region.distance,
    region: {
        country: offer.region.country
    }
});
